import { Component } from '@angular/core';

@Component({
  selector: 'no-kno-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
}
